import { Routes, Route } from "react-router-dom";
import AboutUs from "./Pages/AboutUs";
import Books from "./Pages/Books";
import Contact from "./Pages/Contact";
import SevaPrkalp from "./Pages/SevaPrkalp";
import Home from "./Pages/Home";
import Message from "./Pages/Message";
import PageNotFound from "./Pages/PageNotFound";

import Gallery from "./Pages/Gallery";
import AdminGallery from "./Pages/AdminGallery";

function App() {
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

  return (
    <div className="App bg-gray-50 bg-pattern min-h-screen">
      <Routes>
        <Route exact path="/" element={<Home />}/>
        <Route exact path="/about" element={<AboutUs />}/>
        <Route exact path="/books" element={<Books />}/>
        <Route exact path="/sandesh" element={<Message />}/>
        <Route exact path="/contact" element={<Contact />}/>
        <Route exact path="/seva-prkalp" element={<SevaPrkalp />}/>
        <Route exact path="/gallery" element={<Gallery />}/>
        
        {/* Admin Dashboard - Strictly limited to Localhost for security */}
        {isLocalhost && (
          <Route exact path="/gallery/admin" element={<AdminGallery />}/>
        )}
        
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
}
export default App;